export default [
  'Jazz',
  'MT7-L09',
  'MT7-TL10',
  'Carrera',
  'CRR-L09',
  'CRR-UL00',
  'Next',
  'NXT-L09',
  'NXT-L29',
  'Manhattan',
  'MHA-L09',
  'MHA-L29',
  'Longland',
  'LON-L29',
  'Longland',
  'LON-L29',
  'Alps',
  'ALP-L09',
  'ALP-L29',
  'Blanc',
  'BLA-L09',
  'BLA-A09',
  'BLA-L29',
  'Blanc',
  'BLA-A09',
  'BLA-L29',
  'Rhone',
  'RNE-L01',
  'RNE-L03',
  'RNE-L21',
  'RNE-L23',
  'Bond',
  'BND-L34',
  'Neo',
  'NEO-L29',
  'Hima',
  'HMA-L09',
  'HMA-L29',
  'Laya',
  'LYA-L09',
  'LYA-L0C',
  'LYA-L29',
  'Ever',
  'EVR-L29',
  'EVR-N29',
  'Laya',
  'LYA-L29',
  'Sydneym',
  'SNE-LX1',
  'SNE-LX2',
  'SNE-LX3',
  'Taurus',
  'TAS-L09',
  'TAS-L29',
  'Lion',
  'LIO-L09',
  'LIO-L29',
  'LIO-N29',
  'Lion',
  'LIO-N29',
  'Noah',
  'NOH-NX9',
  'Cetus',
  'CET-LX9',
  'Draco',
  'DCO-LX9',
  'Allen',
  'ALN-LX9',
  'Pillar',
  'PLR-L29',
  'Tahiti',
  'TAH-N29m',
  'Palau',
  'PAL-LX9',
  'PAL-L29',
  'Alta',
  'ALT-L29',
  'Iceland',
  'ICL-LX9',
  'Delphi',
  'DEL-LX9',
  'Greenlan',
  'GRL-LX9',
  'P6-U06',
  'Sophia',
  'P7-L10',
  'P7-L11',
  'P7-L12',
  'Grace',
  'GRA-L09',
  'GRA-UL00',
  'GRA-UL10',
  'Alice',
  'ALE-L02',
  'ALE-L04',
  'ALE-L21',
  'ALE-L23',
  'Prague',
  'PRA-LA1',
  'PRA-LX1',
  'Eva',
  'EVA-L09',
  'EVA-L19',
  'EVA-L29',
  'Vienna',
  'VIE-L09',
  'VIE-L29',
  'Venus',
  'VNS-L21',
  'VNS-L22',
  'VNS-L23',
  'VNS-L31',
  'VNS-L52',
  'VNS-L53',
  'VNS-L62',
  'Victoria',
  'VTR-L09',
  'VTR-L29',
  'Vicky',
  'VKY-L09',
  'VKY-L29',
  'Warsaw',
  'WAS-LX1',
  'WAS-LX1A',
  'WAS-LX2',
  'WAS-LX2J',
  'WAS-LX3',
  'WAS-L03T',
  'Emily',
  'EML-L09',
  'EML-L29',
  'Charlotte',
  'CLT-L04',
  'CLT-L09',
  'CLT-L29',
  'Anne',
  'ANE-LX1',
  'ANE-LX2',
  'ANE-LX2J',
  'ANE-LX3',
  'Elle',
  'ELE-L09',
  'ELE-L29',
  'Vogue',
  'VOG-L09',
  'VOG-L29',
  'Marie',
  'MAR-LX1A',
  'MAR-LX1Am',
  'MAR-LX1B',
  'MAR-LX1M',
  'MAR-LX1Mm',
  'MAR-LX2',
  'MAR-LX2m',
  'MAR-LX2B',
  'MAR-LX2J',
  'MAR-LX3A',
  'MAR-LX3Am',
  'MAR-LX3Bm',
  'Anna',
  'ANA-NX9',
  'Elsa',
  'ELS-N04',
  'ELS-NX9',
  'ELS-NX9',
  'ElsaP',
  'ELS-N39',
  'Jenny',
  'JNY-LX1',
  'JNY-LX2',
  'CindyN',
  'CDY-NX9',
  'Arthur',
  'ART-L29',
  'Jade',
  'JAD-LX4',
  'JAD-LX9',
  'Bali',
  'BAL-L49',
  'BAL-LX9',
  'Leona',
  'LNA-LX9',
  'Mona',
  'MNA-LX9',
  'Audrey',
  'ADY-LX9',
  'Hepburn',
  'HBN-LX9',
  'HepburnP',
  'HBP-LX9',
  'Hedy',
  'HED-LX9',
  'Lamarr',
  'LMR-LX9',
  'LamarrU',
  'LMU-LX9',
  'Figo',
  'FIG-LA1',
  'FIG-LX1',
  'FIG-LX2',
  'FIG-LX3',
  'Sydneyi',
  'INE-LX1',
  'Potter',
  'POT-LX1',
  'POT-LX1AF',
  'POT-LX1RU',
  'POT-LX3',
  'Potter',
  'POT-LX1T',
  'Stark',
  'STK-LX1',
  'Stark',
  'STK-L21',
  'Aquaman',
  'AQM-LX1',
  'Potter',
  'POT-LX1A',
  'Peppa',
  'PPA-LX2',
  'Cannes',
  'CAN-L01',
  'CAN-L02',
  'CAN-L03',
  'CAN-L11',
  'CAN-L12',
  'CAN-L13',
  'Milan',
  'MLA-L01',
  'MLA-L02',
  'MLA-L03',
  'MLA-L11',
  'MLA-L12',
  'MLA-L13',
  'Prague',
  'PRA-LX2',
  'PRA-LX3',
  'Picasso',
  'PIC-L09',
  'PIC-LX9',
  'Barca',
  'BAC-L01',
  'BAC-L03',
  'BAC-L21',
  'BAC-L22',
  'BAC-L23',
  'Rhone',
  'RNE-L02',
  'RNE-L22',
  'London',
  'LDN-LX2',
  'Paris',
  'PAR-LX1',
  'PAR-LX1M',
  'PAR-LX9',
  'PAR-L21',
  'PAR-L29',
  'Sydneyi',
  'INE-LX1',
  'INE-LX1r',
  'INE-LX2',
  'INE-LX2r',
  'Potter',
  'POT-LX2J',
  'Venice',
  'VCE-L22',
  'Yale',
  'YAL-L21',
  'YAL-L41',
  'Jenny',
  'JNY-LX1',
  'CindyN',
  'CDY-NX9',
  'Angela',
  'ANG-LX1',
  'ANG-LX2',
  'Neumann',
  'NEN-LX1',
  'NEN-L22',
  'NEN-LX3',
  'NottinghamN',
  'NAM-LX9',
  'JuliaQN',
  'JLN-LX1',
  'JLN-LX3',
  'Nicole',
  'NCO-LX1',
  'NCO-LX3',
  'Gloria',
  'GLA-LX1',
  'GLA-LX3',
  'Bonnie',
  'BNE-LX1',
  'BNE-LX3',
  'Fiona',
  'FOA-LX9',
  'Gloria',
  'GOA-LX9',
  'Mario',
  'MAO-LX9',
  'MAO-LX9N',
  'Fiona',
  'FOA-LX9',
  'Cartier',
  'CTR-L81',
  'Bonnie',
  'BNE-LX1',
  'BNE-LX3',
  'Blake',
  'BLK-LX9',
  'MillaS',
  'MIS-LX9',
  'Cartier',
  'CTR-L91',
  'TLR-LX9',
  'MIA-LX9',
  'Santiago',
  'STG-LX2',
  'Wukong',
  'WKG-LX9',
  'Eevee',
  'EVE-LX9',
  'EVE-LX9N',
  'EVE-LX3',
  'Mega',
  'MGA-LX9',
  'MGA-LX9N',
  'MGA-LX3',
  'Mega',
  'MGA-LX3',
  'Goofy',
  'GFY-LX1',
  'Cartier',
  'CTR-LX1',
  'CTR-LX2',
  'CTR-LX3',
  'Santiago',
  'STG-LX1',
  'STG-LX2',
  'Dura',
  'DRA-L01',
  'DRA-L21',
  'DRA-LX2',
  'AMN-LX3',
  'AMN-LX9',
  'AMN-LX1',
  'AMN-LX2',
  'AMN-LX3',
  'AMN-LX9',
  'Dura',
  'DRA-LX9',
  'DRA-LX9',
  'Maya',
  'MYA-L11',
  'MYA-L41',
  'Atomu',
  'ATU-LX3',
  'ATU-L21',
  'ATU-L22',
  'ATU-L23',
  'Atomu',
  'ATU-L31',
  'ATU-L42',
  'Merida',
  'MRD-LX1',
  'MRD-LX3',
  'MRD-LX1',
  'MRD-LX1N',
  'MRD-LX3',
  'Merida',
  'MRD-LX1F',
  'Merida',
  'MRD-LX2',
  'Merida',
  'MED-LX9',
  'MED-LX9',
  'MED-LX9N',
  'Jakarta',
  'JAT-LX3',
  'JAT-LX1',
  'JAT-LX3',
  'JAT-L29',
  'Toronto',
  'TRT-LX1',
  'TRT-LX2',
  'TRT-LX3',
  'London',
  'LDN-LX3',
  'London',
  'LDN-L21',
  'Dubai',
  'DUB-LX1',
  'DUB-LX3',
  'DUB-LX1',
  'DUB-LX3',
  'Peppa',
  'PPA-LX3',
  'PPA-LX2',
  'PPA-LX3',
  'Arthur',
  'ART-L28',
  'ART-L28',
  'ART-L29',
  'ART-L29N',
  'Aquaman',
  'AQM-LX1',
  'AQM-LX1',
  'Jackman',
  'JKM-LX1',
  'JKM-LX1',
  'JKM-LX2',
  'JKM-LX3',
  'Florida',
  'FLA-LX1',
  'FLA-LX3',
  'Jackman',
  'JKM-LX3',
  'JKM-LX1',
  'JKM-LX2',
  'JKM-LX3',
  'Stark',
  'STK-LX3',
  'STK-L21',
  'STK-L22',
  'STK-LX3',
  'Franklin',
  'FRL-L21',
  'FRL-L22',
  'FRL-L23',
  'Stark',
  'STK-L21',
  'STK-L21',
  'STK-L22',
  'STK-LX3',
  'S7-701u',
  'S10-231L',
  'Beethoven',
  'BTV-W09',
  'BTV-DL09',
  'Chopin',
  'CPN-W09',
  'CPN-L09',
  'Bach',
  'BAH-W09',
  'BAH-L09',
  'Schubert',
  'SHT-W09',
  'SHT-AL09',
  'Cameron',
  'CMR-W09',
  'CMR-AL09',
  'Cameron',
  'CMR-W19',
  'CMR-AL19',
  'Bach2',
  'BAH2-W19',
  'BAH2-L09',
  'Schumann',
  'SCM-W09',
  'SCM-AL09',
  'Bach3',
  'BAH3-W09',
  'BAH3-L09',
  'Bach4',
  'BAH4-W09',
  'BAH4-L09',
  'Bartok',
  'BTK-W09',
  'BTK-AL09',
  'Debussy',
  'DBY-W09',
  'DebussyR',
  'DBR-W09',
  'DBR-W19',
  'BartokR',
  'BTKR-W09',
  'Tagore',
  'TGR-W09',
  'Taoxingzhi',
  'TXZ-W09',
  'Salinger',
  'SLG-W09',
  'Debussy2',
  'DBY2-W09',
  'DBY2-L09',
  'Banksy',
  'BKY-W09',
  'Laurent',
  'LRT-W09',
  'Marx',
  'MRX-W09',
  'MRX-W29',
  'MRX-AL09',
  'MRX-AN19',
  'Goethe',
  'GOT-W29',
  'GOT-AL09',
  'Wagner',
  'WGR-W09',
  'WGR-W19',
  'WagnerR',
  'WGRR-W09',
  'Poincare',
  'PCE-W29',
  'Weber',
  'WEB-W09',
  'Miro',
  'MRO-W09',
  'Morandi',
  'MRDI-W09',
  'Hemingway',
  'HMW-W09',
  'Baggio',
  'BGO-L03',
  'BGO-DL09',
  'FDR-A01L',
  'Baggio2',
  'BG2-W09',
  'BG2-U01',
  'BG2-U03',
  'Kobe',
  'KOB-W09',
  'KOB-L09',
  'Agassi',
  'AGS-W09',
  'AGS-L03',
  'AGS-L09',
  'Agassi2',
  'AGS2-W09',
  'AGS2-W19',
  'AGS2-L03',
  'AGS2-L09',
  'Kobe2',
  'KOB2-W09',
  'KOB2K-W09',
  'KOB2-L03',
  'KOB2-L09',
  'KOB2K-L09',
  'AgassiR',
  'AGR-W09',
  'AGRK-W09',
  'AGR-L09',
  'AGRK-W09',
  'Agassi3',
  'AGS3-W09',
  'AGS3K-W09',
  'AGS3-L09',
  'AGS3K-L09',
  'Agassi5',
  'AGS5-W09',
  'AGS5-L09',
  'Agassi6',
  'AGS6-W09',
  'AGS6-L09',
  'Kobe2K',
  'KOB2K-W09',
  'KOB2K-L09',
  'AgassiRK',
  'AGRK-W09',
  'AGRK-L09',
  'AgassiRK',
  'AGS3K-L09',
  'Debussy',
  'DBY-W09',
]